export function flowNamePart(name: string, brand?: { name?: string; slug?: string } | null) {
  let result = String(name || '').trim();
  const prefixes = [brand?.name, brand?.slug].filter(Boolean) as string[];
  for (;;) {
    const prefix = prefixes.find(value => result.toLocaleLowerCase().startsWith(value.toLocaleLowerCase() + ' - '));
    if (!prefix) return result;
    result = result.slice(prefix.length + 3).trim();
  }
}
export function brandedFlowName(name: string, brand?: { name?: string; slug?: string } | null) {
  const part = flowNamePart(name, brand);
  return brand?.name ? `${brand.name} - ${part}` : part;
}
